module.exports = __webpack_public_path__ + "static/media/trash-icon.5c376f87.svg";